import { useTranslation } from 'react-i18next';
import SearchBox from '../../../components/SearchBox';

const FarmerSearch = ({ onSearch }) => {
  const { t } = useTranslation();
  return (
    <SearchBox
      className="farmer-search"
      placeholder={t('common.filters.searchFarmers')}
      onSearch={onSearch}
      enterButton
      showLabel={false}
    />
  );
};

export default FarmerSearch;
